import React, {FC} from "react"
import {Button, Card, CardImg, Col, Container, Row, Stack} from "react-bootstrap"
import {useTranslation} from "react-i18next"
import {useNavigate} from "react-router-dom"
import DSLR1 from './dlsr1.jpg'
import DSLR2 from './dlsr2.jpg'
import DSLR3 from './dlsr3.jpg'
import DSLR4 from './dlsr4.jpg'
import DSLR5 from './dlsr5.jpg'
import TOUR1 from './threesitxy1.png'
import {useTheme} from "../../context/ThemeProvider"

type InfoComponentProps = Record<string, unknown>

const InfoComponent: FC<InfoComponentProps> = () => {
    const {t} = useTranslation("info")
    const nav = useNavigate()
    const theme = useTheme()

    return (
        <div className="component">
            <Container fluid="lg" className="px-3 px-md-4">
                <Row className="justify-content-center">
                    <Col xs={12}>
                        <Card className="shadow-sm">
                            <Card.Header>
                                <h1 className="h2 mb-0">
                                    <img
                                        src={theme.getTheme() === "dark" ? "/favicon.svg" : "/favicon-light.svg"}
                                        style={{
                                            height: "1em",
                                            width: "auto",
                                            verticalAlign: "-0.1em",
                                        }}
                                        className="d-inline-block align-top"
                                        alt="Exam console logo"
                                    />{" "}
                                    {t('info.title')}
                                </h1>
                            </Card.Header>

                            <Card.Body className="p-3 p-md-4 p-xl-5">
                                <Row className="g-4 g-lg-5 align-items-center">
                                    <Col xs={12} lg={6}>
                                        <Card className="overflow-hidden">
                                            <CardImg src={DSLR1} className="img-fluid" alt=""/>
                                        </Card>
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <section>
                                            <h2 className="h3">
                                                <i className="bi bi-question-circle"></i>{" "}
                                                {t('info.subtitle1')}
                                            </h2>
                                            <hr/>
                                            <p>{t('info.p1.1')}</p>
                                            <p>
                                                {t('info.p1.2')}{" "}
                                                <a
                                                    href="https://www.intern.tu-darmstadt.de/verwaltung/dez_ii/studienprogramme/quis/quis_flex.de.jsp"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {t('info.p1.3')}{" "}
                                                    <i className="bi bi-box-arrow-up-right ms-1"></i>
                                                </a>{" "}
                                                {t('info.p1.4')}
                                            </p>
                                        </section>
                                    </Col>
                                </Row>

                                <Row className="g-4 g-lg-5 align-items-center mt-4 mt-lg-5">
                                    <Col xs={12} lg={6} className="order-2 order-lg-1">
                                        <section>
                                            <h2 className="h3">
                                                <i className="bi bi-person-workspace"></i>{" "}
                                                {t('info.subtitle2')}
                                            </h2>
                                            <hr/>
                                            <p>
                                                {t('info.p2.1')}{" "}
                                                <a
                                                    href="https://www.e-learning.tu-darmstadt.de/werkzeuge/e_pruefungen/leistungsumfang/index.de.jsp"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {t('info.p2.2')}{" "}
                                                    <i className="bi bi-box-arrow-up-right ms-1"></i>
                                                </a>{" "}
                                                {t('info.p2.3')}
                                            </p>
                                            <p>{t('info.p2.4')}</p>
                                            <p>{t('info.p2.5')}</p>
                                        </section>
                                    </Col>

                                    <Col xs={12} lg={6} className="order-1 order-lg-2">
                                        <Card className="overflow-hidden">
                                            <CardImg src={DSLR2} className="img-fluid" alt=""/>
                                        </Card>
                                    </Col>
                                </Row>

                                <Row className="g-4 g-lg-5 align-items-center mt-4 mt-lg-5">
                                    <Col xs={12} lg={6}>
                                        <Card className="overflow-hidden">
                                            <CardImg src={DSLR3} className="img-fluid" alt=""/>
                                        </Card>
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <section>
                                            <h2 className="h3">
                                                <i className="bi bi-translate"></i>{" "}
                                                {t('info.subtitle3')}
                                            </h2>
                                            <hr/>
                                            <p>{t('info.p3.1')}</p>
                                            <p>{t('info.p3.2')}</p>
                                        </section>
                                    </Col>
                                </Row>

                                <Row className="mt-5">
                                    <Col xs={12}>
                                        <h2 className="h3 text-center">
                                            <i className="bi bi-binoculars"></i>{" "}
                                            {t('info.subtitle4')}
                                        </h2>
                                        <hr/>
                                    </Col>
                                </Row>

                                <Row className="g-4 mt-1">
                                    <Col xs={12} lg={4}>
                                        <Card className="h-100 shadow-sm">
                                            <CardImg src={DSLR4} className="img-fluid" alt=""/>
                                            <Card.Body>
                                                <p>{t('info.p4.1')}</p>
                                                <ul className="mb-3">
                                                    <li>{t('info.p4.u1')}</li>
                                                    <li>{t('info.p4.u2')}</li>
                                                    <li>{t('info.p4.u3')}</li>
                                                    <li>{t('info.p4.u4')}</li>
                                                </ul>
                                                <p className="mb-0">{t('info.p4.2')}</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col xs={12} lg={4}>
                                        <Card className="h-100 shadow-sm">
                                            <CardImg src={TOUR1} className="img-fluid" alt=""/>
                                            <Card.Body>
                                                <p>
                                                    {t('info.p6.1')}{" "}
                                                    <a
                                                        href="https://www.e-learning.tu-darmstadt.de/werkzeuge/360_ar_vr_lernumgebungen/360grad/index.de.jsp"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Future Learning Spaces{" "}
                                                        <i className="bi bi-box-arrow-up-right ms-1"></i>
                                                    </a>{" "}
                                                    {t('info.p6.2')}
                                                </p>
                                                <p>{t('info.p6.3')}</p>
                                                <p className="mb-0">{t('info.p6.4')}</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col xs={12} lg={4}>
                                        <Card className="h-100 shadow-sm">
                                            <CardImg src={DSLR5} className="img-fluid" alt=""/>
                                            <Card.Body>
                                                <p>{t('info.p5.1')}</p>
                                                <p>{t('info.p5.2')}</p>
                                                <p className="mb-0">{t('info.p5.3')}</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                <Stack
                                    direction="horizontal"
                                    gap={3}
                                    className="flex-column flex-md-row justify-content-center align-items-stretch mt-5"
                                >
                                    <Button
                                        onClick={() => nav("/faq")}
                                        size="lg"
                                        className="w-100 w-md-auto"
                                    >
                                        {t('info.p4.btn')}
                                    </Button>

                                    <Button
                                        as="a"
                                        href="https://asset.e-learning.tu-darmstadt.de/d/pruefungondemand_360/"
                                        target="_blank"
                                        rel="noreferrer"
                                        variant="success"
                                        size="lg"
                                        className="w-100 w-md-auto"
                                    >
                                        {t('info.p6.btn')}
                                    </Button>

                                    <Button
                                        onClick={() => nav("/booking")}
                                        size="lg"
                                        variant="warning"
                                        className="w-100 w-md-auto"
                                    >
                                        {t('info.p5.btn')}
                                    </Button>
                                </Stack>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default InfoComponent